import React from 'react'
import NumberFormat from 'react-number-format'

export default function Pesos(props) {
  return (
    <NumberFormat
      displayType="text"
      prefix="$ "
      decimalScale={2}
      allowLeadingZeros={false}
      thousandSeparator={'.'}
      decimalSeparator={','}
      isNumericString={true}
      {...props}
    />
  )
}
